export const REDIRECT_MESSAGES_BY_LANGUAGE = {
    en: "Your call will be redirected. Thank you!",
    mk: "Вашиот повик ќе биде пренасочен. Ви благодариме!",
    sr: "Vaš poziv će biti preusmeren. Hvala vam!",
    hr: "Vaš poziv će biti preusmjeren. Hvala vam!",
    sq: "Thirrja juaj do të ridrejtohet. Faleminderit!",
    al: "Thirrja juaj do të ridrejtohet. Faleminderit!",
    pl: "Twoje połączenie zostanie przekierowane. Dziękujemy!",
    uk: "Ваш дзвінок буде перенаправлено. Дякуємо!",
};
